import React, { useState } from "react";
import { Mail, User, Building2, Copy, Check } from "lucide-react";

const GeneralSettings = ({ userData }) => {
  const [copiedField, setCopiedField] = useState(null);

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000);
  };

  const fields = [
    {
      id: "name",
      label: "Full Name",
      value: userData?.name || "Not provided",
      icon: <User size={18} strokeWidth={1.5} />,
    },
    {
      id: "email",
      label: "Email Address",
      value: userData?.email || "Not provided",
      icon: <Mail size={18} strokeWidth={1.5} />,
    },
    {
      id: "organization",
      label: "Organization",
      value: userData?.organizationName || userData?.organization?.name || "Not provided",
      icon: <Building2 size={18} strokeWidth={1.5} />,
    },
  ];

  return (
    <div className="space-y-3 md:space-y-4">
      {/* Profile Information */}
      <div className="mt-2 md:mt-6 space-y-3">
        {fields.map((field) => (
          <div
            key={field.id}
            className="flex items-center justify-between p-3 md:p-4 bg-bg-60 rounded-lg hover:bg-bg-50 transition-colors"
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="text-fg-60 flex-shrink-0">{field.icon}</div>
              <div className="min-w-0 flex-1">
                <label className="block text-xs font-medium text-fg-60 mb-1">
                  {field.label}
                </label>
                <p className="text-sm md:text-base text-fg-50 font-medium break-words">
                  {field.value}
                </p>
              </div>
            </div>
            <button
              onClick={() => copyToClipboard(field.value, field.id)}
              className="p-2 ml-2 text-fg-60 hover:text-fg-50 transition-colors flex-shrink-0 rounded-full touch-manipulation"
              title="Copy to clipboard"
            >
              {copiedField === field.id ? (
                <Check size={18} className="text-green-500" />
              ) : (
                <Copy size={18} strokeWidth={1.5} />
              )}
            </button>
          </div>
        ))}
      </div>

      {/* Account Type and Member Since */}
      <div className="space-y-3 mt-4 md:mt-6">
        <div className="p-3 md:p-4 bg-bg-60 rounded-lg">
          <p className="text-xs font-medium text-fg-60 mb-1.5">Account Type</p>
          <p className="text-sm md:text-base font-medium text-fg-50 capitalize">
            {userData?.role || "User"}
          </p>
        </div>
        <div className="p-3 md:p-4 bg-bg-60 rounded-lg">
          <p className="text-xs font-medium text-fg-60 mb-1.5">Member Since</p>
          <p className="text-sm md:text-base font-medium text-fg-50">
            {userData?.createdAt
              ? new Date(userData.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "Unknown"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
